import TechnicalSkill from '../../models/technical-skills';
import { Engineer } from '../../models/engineer';
import useTechSkills from '../../hooks/useTechSkills';
import { useEngineer } from '../EngineerProvider';

export interface EngineerWithSkills extends Engineer {
  skills: TechnicalSkill[];
}

export default function useEngineerWithSkills() {
  const { skills, fetchingSkills } = useTechSkills();
  const { engineer: engBase, fetching: fetchingEngineer, reload } = useEngineer();
  const engineer = engBase && skills
    ? {
      ...engBase,
      skills: engBase.skillIds.map((id) => skills.find((sk) => sk.id === id)).filter(Boolean),
    }
    : null;
  return {
    fetching: fetchingSkills || fetchingEngineer,
    engineer: engineer as EngineerWithSkills,
    reload,
  };
}
